"use client";

import { Ticket, ListOrdered, Bell } from "lucide-react";
import type { DropEntryMode } from "@/types/drop";

type ShellState = "not_started" | "open" | "closed" | "pending" | "waitlist" | "entry";
type ShellMode = DropEntryMode | "notify" | "waitlist" | "restock" | "standard";

export default function EntryShell({
  mode,
  state,
  children,
}: {
  mode: ShellMode;
  state: ShellState;
  children: React.ReactNode;
}) {
  const isRaffle = mode === "raffle";
  const isQueue = mode === "queue";
  const label =
    mode === "raffle" ? "RAFFLE" :
    mode === "queue" ? "QUEUE" :
    mode === "waitlist" ? "WAITLIST" :
    mode === "restock" ? "RESTOCK" :
    mode === "standard" ? "STANDARD" : "NOTIFY";
  const tone =
    isRaffle ? "bg-amber-500 text-black" :
    isQueue ? "bg-violet-600 text-white" :
    mode === "waitlist" ? "bg-amber-500 text-black" :
    "bg-foreground text-background";
  const Icon = isRaffle ? Ticket : isQueue ? ListOrdered : Bell;
  const stateLabel =
    state === "not_started" ? "Opens soon" :
    state === "closed" ? "Closed" :
    state === "pending" ? "Confirmed" :
    state === "waitlist" ? "Waitlist" : "Open";

  return (
    <div className="w-full max-w-xl overflow-hidden border border-foreground/15 bg-background">
      <div className="flex min-h-[128px]">
        <div className={`hidden sm:flex w-[36px] shrink-0 self-stretch items-center justify-center border-r border-foreground/12 ${tone}`}>
          <span className="rotate-180 whitespace-nowrap text-[10px] font-black tracking-[0.22em] uppercase" style={{ writingMode: "vertical-rl" }}>
            {label} · MONOCHROME
          </span>
        </div>
        <div className="min-w-0 flex-1 p-5 sm:p-6">
          <div className="mb-4 flex items-center gap-2">
            <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] font-black tracking-[0.14em] uppercase ${tone}`}>
              <Icon className="h-3 w-3" /> {label}
            </span>
            <span className="text-muted-foreground font-mono text-[10px] tracking-widest uppercase">{stateLabel}</span>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
